export default __webpack_public_path__ + "static/media/next-slide.a4936ef4.svg";